'use client'
import { Button } from '@/components/ui/button'
import BlockWrapper from '@/components/BlockWrapper'

const CommentBlockComponent = (props: any) => {
  const { fields } = props
  return (
    <BlockWrapper>
      <div className="container">
        <div className="flex flex-col items-center justify-center mb-10">
          <h2 className="font-light text-primary text-2xl md:text-[28px]  text-center tracking-[0] leading-7 [font-family:'Open_Sans',Helvetica]">
            Leave Comment
          </h2>
        </div>
        <form onSubmit={() => {}} className="space-y-6 flex flex-col justify-between ">
          <div className="grid md:grid-cols-2 gap-6">
            {fields?.map((field: any, i: any) => {
              const type = field?.field_type
              return (
                <div key={i}>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    {field?.field_label}
                  </label>
                  {type === 'textarea' ? (
                    <textarea
                      id={field?.field_name}
                      name={field?.field_name}
                      //   value={formData?.[field?.field_name] || ''}
                      //   onChange={handleInputChange}
                      placeholder={field?.field_placeholder}
                      className="w-full px-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
                      required
                    />
                  ) : (
                    <input
                      type={field?.field_type || 'text'}
                      id={field?.field_name}
                      name={field?.field_name}
                      //   value={formData?.[field?.field_name] || ''}
                      //   onChange={handleInputChange}
                      placeholder={field?.field_placeholder}
                      className="w-full px-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
                      required
                    />
                  )}
                </div>
              )
            })}
          </div>

          <div className="flex flex-1 justify-end ">
            <Button
              type="submit"
              variant={'destructive'}
              className=" bg-destructive hover:bg-slate-700 text-white font-semibold px-8 py-4 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <span>Comment</span>
            </Button>
          </div>
        </form>
      </div>
    </BlockWrapper>
  )
}

export default CommentBlockComponent
